// import React from "react";
// import floatingImg from "../../assets/Technical_Proposal_FDC__2_-removebg-preview.png"
// import iconImg from "../../assets/Technical_Proposal_FDC__2_-removebg-preview.png"
// export function renderExploreNetraa() {
//   return (

//   <div
//     className="flex-1"
//     id="main-content-area"
//   >
//     {/* CENTERED CONTAINER */}
//     <div className="transition-opacity duration-300">

//       {/* ================= HERO / SUITE OVERVIEW ================= */}
//       <section className="scroll-mt-24 relative" id="suite-overview">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

//           {/* LEFT SIDE */}
//           <div className="z-10">
//             <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-100 dark:bg-orange-900/30 text-primary text-xs font-bold uppercase tracking-wider mb-2 border border-orange-200 dark:border-orange-800/50 shadow-glow-sm">
//               <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
//               System Live
//             </div>

//             <h1 className="text-5xl lg:text-7xl font-black text-text-main dark:text-white tracking-tighter mb-6 leading-none">
//               Explore <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">Netraa</span>
//               <br />
//               <span className="text-4xl lg:text-4xl font-light block mt-4">Your Command Center</span>
//             </h1>

//             <p className="text-xl text-text-muted dark:text-gray-400 leading-relaxed mb-8">
//               A unified observability platform transforming chaos into clarity. From <span className="text-primary font-medium">Full-Stack Monitoring</span> to <span className="text-primary font-medium">Predictive AI-Ops</span>.
//             </p>

//             <div className="flex flex-wrap gap-4">
//               <button onClick={() => window.location.href = "https://ap2l.ai"} className="px-8 py-4 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-lg font-bold shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50 transform hover:-translate-y-1 transition-all">
//               Book Demo
//               </button>
//             </div>
//           </div>
//   {/* RIGHT SIDE FLOATING IMAGE */}
// <div className="relative h-[500px] w-full flex items-center justify-center perspective-1000">
//   <div className="relative w-80 h-80">
//     <img
//       src={floatingImg} 
//       className="absolute inset-0 w-full h-full object-contain animate-float-slow"
//     />
//   </div>
// </div>
// </div>
// </section>
// {/* ================= PRODUCT GRID ================= */}
// <section className="m-auto mt-10 scroll-mt-24" id="product-grid">
//   <div className="mb-10">
//     <h2 className="text-3xl font-bold mb-2">Advanced Product Grid</h2>
//     <p className="text-text-muted">
//       High-fidelity modules for every layer of your stack
//     </p>
//   </div>

//   <div className="grid grid-cols-1 md:grid-cols-2 gap-3">

//     {/* -------- Netraa APM -------- */}
//     <div className="glass-panel rounded-2xl p-6 border border-orange-300">
//       <div className="flex items-center mb-6 gap-2">
//         <div className="p-1 rounded-xl flex items-center justify-center">
//           <img
//             src={iconImg}
//             alt="Monitoring"
//             className="w-8 h-8"
//           />
//         </div>
//         <div>
//           <h3 className="text-2xl font-bold">Netraa APM</h3>
//           <p className="text-sm uppercase text-orange-500">
//             Code-Level Insights
//           </p>
//         </div>
//       </div>

//       <div className="h-16 flex items-end gap-1 mb-6 bg-orange-50 rounded-lg p-1">
//         <div className="w-1/6 h-[40%] bg-orange-300"></div>
//         <div className="w-1/6 h-[60%] bg-orange-400"></div>
//         <div className="w-1/6 h-[30%] bg-orange-300"></div>
//         <div className="w-1/6 h-[80%] bg-orange-400"></div>
//         <div className="w-1/6 h-[50%] bg-orange-500"></div>
//         <div className="w-1/6 h-[75%] bg-orange-600"></div>
//       </div>

//       <div className="space-y-3 mb-6">
//         <div className="flex gap-1 text-sm">
//           <span className="material-symbols-outlined text-orange-500">code</span>
//           Full Stack Monitoring
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-orange-500">speed</span>
//           Root Cause Analysis
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-orange-500">speed</span>
//           Infrastructure Monitoring
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-orange-500">speed</span>
//           Message Queue Monitoring
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-orange-500">speed</span>
//           Cloud Monitoring
//         </div>
//       </div>

//       <a className="text-orange-600 font-bold">
//         & Many more ...
//       </a>
//     </div>

//     {/* -------- Netraa LH -------- */}
//     <div className="glass-panel rounded-2xl p-6 border border-blue-300">
//       <div className="flex items-center mb-6 gap-2">
//         <div className="p-1 rounded-xl flex items-center justify-center">
//           <img
//             src={iconImg}
//             alt="Monitoring"
//             className="w-8 h-8"
//           />
//         </div>
//         <div>
//           <h3 className="text-2xl font-bold">Netraa LH</h3>
//           <p className="text-sm uppercase text-blue-500">
//             Synthetic Monitoring Aid
//           </p>
//         </div>
//       </div>

//       <pre className="text-xs font-mono bg-blue-50 p-3 rounded mb-6 text-blue-600">
//         <p className="m-0">INFO:Service started on port:8080</p>
//         <p className="m-0">WARN:High memory usage detected</p>
//         <p className="m-0">INFO:User login successful<br/>(ID:442)</p>
//       </pre>

//       <div className="space-y-3 mb-6">
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-blue-500">search</span>
//           Live Executions of Monitors
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-blue-500">storage</span>
//           Availability & Error Tracking
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-blue-500">storage</span>
//           HAR Data Analysis
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-blue-500">storage</span>
//           Granular Level Performance Tracking
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-blue-500">storage</span>
//           Competitive Benchmarking
//         </div>
//       </div>

//       <a className="text-blue-600 font-bold">
//         & Many more ...
//       </a>
//     </div>

//     {/* -------- Netraa SRG -------- */}
//     <div className="glass-panel rounded-2xl p-6 border border-green-300">
//       <div className="flex items-center mb-10 gap-2">
//         <div className="p-1 rounded-xl flex items-center justify-center">
//           <img
//             src={iconImg}
//             alt="Monitoring"
//             className="w-8 h-8"
//           />
//         </div>
//         <div>
//           <h3 className="text-2xl font-bold">Netraa SRG</h3>
//           <p className="text-sm uppercase text-green-500">
//             Service Reliability
//           </p>
//         </div>
//       </div>

//       <div className="mb-6">
//         <div className="flex justify-between text-xs mb-1">
//           <span>SLO Budget</span>
//           <span>98% Rem.</span>
//         </div>
//         <div className="h-2 bg-green-100 rounded">
//           <div className="h-full w-[98%] bg-green-500 rounded"></div>
//         </div>
//       </div>

//       <div className="space-y-3 mb-6">
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-green-500">sync</span>
//           Capacity Planner
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-green-500">balance</span>
//           Network Monitoring
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-green-500">balance</span>
//           Software Metering
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-green-500">balance</span>
//           Dedicated Sectional Dashboard
//         </div>
//       </div>

//       <a className="text-green-600 font-bold">
//         & Many more ...
//       </a>
//     </div>

//     {/* -------- Netraa AI Ops -------- */}
//     <div className="glass-panel rounded-2xl p-6 border border-purple-300">
//   <div className="flex items-center mb-6 gap-2">
//     <div className="p-1 rounded-xl flex items-center justify-center">
//       <img
//         src={iconImg}
//         alt="Monitoring"
//         className="w-8 h-8"
//       />
//     </div>
//     <div className="whitespace-nowrap">
//       <h3 className="text-2xl font-bold">Netraa AIOps</h3>
//       <p className="text-sm uppercase text-purple-500">
//         Intelligent Automation
//       </p>
//     </div>
//   </div>

//       <div className="h-16 flex items-end gap-2 mb-6">
//         <div className="w-2 h-[40%] bg-purple-300"></div>
//         <div className="w-2 h-[70%] bg-purple-400"></div>
//         <div className="w-2 h-[50%] bg-purple-500"></div>
//         <div className="w-2 h-[90%] bg-purple-600"></div>
//       </div>

//       <div className="space-y-3 mb-6">
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-purple-500">warning</span>
//           Gen-AI Driven Dashboard Summarization
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-purple-500">refresh</span>
//           RAG Documentation Intelligence
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-purple-500">refresh</span>
//           Predictive Modeling with Seasonality
//         </div>
//         <div className="flex gap-2 text-sm">
//           <span className="material-symbols-outlined text-purple-500">refresh</span>
//           Causal AI for true root cause identification
//         </div>
//       </div>

//       <a className="text-purple-600 font-bold">
//         & Many more ...
//       </a>
//     </div>
//   </div>
// </section>

//     {/* ================= ARCHITECTURE FLOW ================= */}
//     {/* <section className="mb-24" id="architecture">
//       <div className="border-l-4 border-orange-500 pl-6 mb-10 mt-6">
//         <h2 className="text-2xl font-bold">The Netraa Difference</h2>
//         <p className="text-text-muted">
//           Watch how data flows seamlessly through our unified architecture.
//         </p>
//       </div>

// <div className="flex justify-between items-center bg-white dark:bg-gray-900 rounded-2xl p-8 border"> */}
//   {/* {[ */}
//     {/* // { label: 'End User', sub: 'Log Harmony', icon: 'person', color: 'blue' },
//   //   { label: 'Application', sub: 'Netraa APM', icon: 'layers', color: 'orange' },
//   //   { label: 'Infrastructure', sub: 'Netraa SRG', icon: 'dns', color: 'green' },
//   //   { label: 'AI Brain', sub: 'Automated Resolution', icon: 'psychology', color: 'purple' },
//   // ].map((n, i, arr) => (
//   //   <React.Fragment key={n.label}>

//   //     {/* Block */}
//   {/* //     <div className="flex flex-col items-center gap-3 w-40">
//   //       <div */} 
//   {/* //         className={`w-16 h-16 rounded-2xl flex items-center justify-center ${ */}
//   {/* //           n.color === 'blue'
//   //             ? 'bg-blue-500'
//   //             : n.color === 'orange'
//       //         ? 'bg-orange-500'
//       //         : n.color === 'green'
//       //         ? 'bg-green-500'
//       //         : 'bg-purple-500'
//       //     } text-white`}
//       //   >
//       //     <span className="material-symbols-outlined">{n.icon}</span>
//       //   </div>
//       //   <div className="text-center">
//       //     <div className="font-bold text-sm">{n.label}</div>
//       //     <div className="text-[10px] text-gray-500 dark:text-gray-400">{n.sub}</div>
//       //   </div>
//       // </div> */}

//       {/* Arrow between blocks */}
//       {/* {i !== arr.length - 1 && (
//         <MdOutlineKeyboardArrowRight className="text-3xl text-gray-400 dark:text-gray-500" />
//       )} */}
// {/* 
//     </React.Fragment> */}
//   {/* ))} */}
// {/* </div>


//     </section> */}

//     {/* ================= METRICS ================= */}
//     <section className="grid grid-cols-1 md:grid-cols-3 mt-12 gap-8 text-center" id="metrics">
//       <div>
//         <div className="text-5xl font-bold text-orange-500">50%</div>
//         <div className="font-bold">Reduction in MTTR</div>
//         <p className="text-sm text-text-muted">
//           Resolve incidents faster with automation.
//         </p>
//       </div>
//       <div>
//         <div className="text-5xl font-bold text-orange-500">30%</div>
//         <div className="font-bold">Cost Savings</div>
//         <p className="text-sm text-text-muted">
//           Optimize infrastructure spend.
//         </p>
//       </div>
//       <div>
//         <div className="text-5xl font-bold text-orange-500">99.9%</div>
//         <div className="font-bold">SLA Compliance</div>
//         <p className="text-sm text-text-muted">
//           Consistently meet SLAs.
//         </p>
//       </div>
//     </section>
//   </div>
// </div>
// );
// }

import React from "react";
import { Link } from "react-router-dom";
import floatingImg from "../../assets/Technical_Proposal_FDC__2_-removebg-preview.png";
import iconImg from "../../assets/Technical_Proposal_FDC__2_-removebg-preview.png";

export function renderExploreNetraa() {
  return (
    <div className="flex-1" id="main-content-area">
      {/* CENTERED CONTAINER */}
      <div className="transition-opacity duration-300">
        {/* ================= HERO / SUITE OVERVIEW ================= */}
        <section className="scroll-mt-24 relative" id="suite-overview">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* LEFT SIDE */}
            <div className="z-10">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-100 dark:bg-orange-900/30 text-primary text-xs font-bold uppercase tracking-wider mb-2 border border-orange-200 dark:border-orange-800/50 shadow-glow-sm">
                <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
                System Live
              </div>

              <h1 className="text-5xl lg:text-7xl font-black text-text-main dark:text-white tracking-tighter mb-6 leading-none">
                Explore{" "}
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
                  Netraa
                </span>
                <br />
                <span className="text-4xl lg:text-4xl font-light block mt-4">
                  Your Command Center
                </span>
              </h1>

              <p className="text-xl text-text-muted dark:text-gray-400 leading-relaxed mb-8">
                A unified observability platform transforming chaos into clarity.
                From{" "}
                <span className="text-primary font-medium">
                  Full-Stack Monitoring
                </span>{" "}
                to{" "}
                <span className="text-primary font-medium">
                  Predictive AI-Ops
                </span>
                .
              </p>

              <div className="flex flex-wrap gap-4">
                <button
                  onClick={() => (window.location.href = "https://cliqtest.com/book-a-demo")}
                  className="px-8 py-4 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-lg font-bold shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50 transform hover:-translate-y-1 transition-all"
                >
                  Book Demo
                </button>
              </div>
            </div>

            {/* RIGHT SIDE FLOATING IMAGE */}
            <div className="relative h-[500px] w-full flex items-center justify-center perspective-1000">
              <div className="relative w-80 h-80">
                <img
                  src={floatingImg}
                  alt="Explore Netraa"
                  className="absolute inset-0 w-full h-full object-contain animate-float-slow"
                />
              </div>
            </div>
          </div>
        </section>

        {/* ================= PRODUCT GRID ================= */}
        <section className="m-auto mt-10 scroll-mt-24" id="product-grid">
          <div className="mb-10">
            <h2 className="text-3xl font-bold mb-2">Advanced Product Grid</h2>
            <p className="text-text-muted">
              High-fidelity modules for every layer of your stack
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {/* -------- Netraa APM -------- */}
            <Link
              to="/gettingStarted"
              className="block no-underline text-inherit hover:scale-[1.01] transition-transform"
            >
              <div className="glass-panel rounded-2xl p-6 border border-orange-300 h-full">
                <div className="flex items-center mb-6 gap-2">
                  <div className="p-1 rounded-xl flex items-center justify-center">
                    <img src={iconImg} alt="Monitoring" className="w-8 h-8" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold">Netraa APM</h3>
                    <p className="text-sm uppercase text-orange-500">
                      Code-Level Insights
                    </p>
                  </div>
                </div>

                <div className="h-16 flex items-end gap-1 mb-6 bg-orange-50 rounded-lg p-1">
                  <div className="w-1/6 h-[40%] bg-orange-300"></div>
                  <div className="w-1/6 h-[60%] bg-orange-400"></div>
                  <div className="w-1/6 h-[30%] bg-orange-300"></div>
                  <div className="w-1/6 h-[80%] bg-orange-400"></div>
                  <div className="w-1/6 h-[50%] bg-orange-500"></div>
                  <div className="w-1/6 h-[75%] bg-orange-600"></div>
                </div>

                <div className="space-y-3 mb-6">
                  <div className="flex gap-1 text-sm">
                    <span className="material-symbols-outlined text-orange-500">
                      code
                    </span>
                    Full Stack Monitoring
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-orange-500">
                      speed
                    </span>
                    Root Cause Analysis
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-orange-500">
                      speed
                    </span>
                    Infrastructure Monitoring
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-orange-500">
                      speed
                    </span>
                    Message Queue Monitoring
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-orange-500">
                      speed
                    </span>
                    Cloud Monitoring
                  </div>
                </div>

                <span className="text-orange-600 font-bold">
                  & Many more ...
                </span>
              </div>
            </Link>

            {/* -------- Netraa LH -------- */}
            <Link
              to="/netraaLH"
              className="block no-underline text-inherit hover:scale-[1.01] transition-transform"
            >
              <div className="glass-panel rounded-2xl p-6 border border-blue-300 h-full">
                <div className="flex items-center mb-6 gap-2">
                  <div className="p-1 rounded-xl flex items-center justify-center">
                    <img src={iconImg} alt="Monitoring" className="w-8 h-8" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold">Netraa LH</h3>
                    <p className="text-sm uppercase text-blue-500">
                      Synthetic Monitoring Aid
                    </p>
                  </div>
                </div>

                <pre className="text-xs font-mono bg-blue-50 p-3 rounded mb-6 text-blue-600">
                  <p className="m-0">INFO:Service started on port:8080</p>
                  <p className="m-0">WARN:High memory usage detected</p>
                  <p className="m-0">
                    INFO:User login successful
                    <br />
                    (ID:442)
                  </p>
                </pre>

                <div className="space-y-3 mb-6">
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-blue-500">
                      search
                    </span>
                    Live Executions of Monitors
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-blue-500">
                      storage
                    </span>
                    Availability & Error Tracking
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-blue-500">
                      storage
                    </span>
                    HAR Data Analysis
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-blue-500">
                      storage
                    </span>
                    Granular Level Performance Tracking
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-blue-500">
                      storage
                    </span>
                    Competitive Benchmarking
                  </div>
                </div>

                <span className="text-blue-600 font-bold">
                  & Many more ...
                </span>
              </div>
            </Link>

            {/* -------- Netraa SRG --------
            <Link
              to="/netraa/srg"
              className="block no-underline text-inherit hover:scale-[1.01] transition-transform"
            >
              <div className="glass-panel rounded-2xl p-6 border border-green-300 h-full">
                <div className="flex items-center mb-10 gap-2">
                  <div className="p-1 rounded-xl flex items-center justify-center">
                    <img src={iconImg} alt="Monitoring" className="w-8 h-8" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold">Netraa SRG</h3>
                    <p className="text-sm uppercase text-green-500">
                      Service Reliability
                    </p>
                  </div>
                </div>

                <div className="mb-6">
                  <div className="flex justify-between text-xs mb-1">
                    <span>SLO Budget</span>
                    <span>98% Rem.</span>
                  </div>
                  <div className="h-2 bg-green-100 rounded">
                    <div className="h-full w-[98%] bg-green-500 rounded"></div>
                  </div>
                </div>

                <div className="space-y-3 mb-6">
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-green-500">
                      sync
                    </span>
                    Capacity Planner
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-green-500">
                      balance
                    </span>
                    Network Monitoring
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-green-500">
                      balance
                    </span>
                    Software Metering
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-green-500">
                      balance
                    </span>
                    Dedicated Sectional Dashboard
                  </div>
                </div>

                <span className="text-green-600 font-bold">
                  & Many more ...
                </span>
              </div>
            </Link> */}

            {/* -------- Netraa SRG (COMING SOON) -------- */}
<div className="relative group opacity-80">

  {/* CARD */}
  <div className="glass-panel rounded-2xl p-6 border border-green-300 h-full pointer-events-none">
    
    <div className="flex items-center mb-10 gap-2">
      <div className="p-1 rounded-xl flex items-center justify-center">
        <img src={iconImg} alt="Monitoring" className="w-8 h-8" />
      </div>

      <div>
        <h3 className="text-2xl font-bold">Netraa SRG</h3>
        <p className="text-sm uppercase text-green-500">
          Service Reliability
        </p>
      </div>
    </div>

    <div className="mb-6">
      <div className="flex justify-between text-xs mb-1">
        <span>SLO Budget</span>
        <span>98% Rem.</span>
      </div>
      <div className="h-2 bg-green-100 rounded">
        <div className="h-full w-[98%] bg-green-500 rounded"></div>
      </div>
    </div>

    <div className="space-y-3 mb-6">
      <div className="flex gap-2 text-sm">
        <span className="material-symbols-outlined text-green-500">
          sync
        </span>
        Capacity Planner
      </div>

      <div className="flex gap-2 text-sm">
        <span className="material-symbols-outlined text-green-500">
          balance
        </span>
        Network Monitoring
      </div>

      <div className="flex gap-2 text-sm">
        <span className="material-symbols-outlined text-green-500">
          balance
        </span>
        Software Metering
      </div>

      <div className="flex gap-2 text-sm">
        <span className="material-symbols-outlined text-green-500">
          balance
        </span>
        Dedicated Sectional Dashboard
      </div>
    </div>

    <span className="text-green-600 font-bold">
      & Many more ...
    </span>
  </div>

  {/* OVERLAY BADGE */}
  <div className="absolute inset-0 flex items-center justify-center rounded-2xl bg-black/10 dark:bg-black/40 backdrop-blur-sm">
    <span className="px-4 py-2 bg-green-600 text-white text-sm font-bold rounded-lg shadow-lg">
      Coming Soon...
    </span>
  </div>

</div>

            {/* -------- Netraa AI Ops -------- */}
            <Link
              to="/AiOverview"
              className="block no-underline text-inherit hover:scale-[1.01] transition-transform"
            >
              <div className="glass-panel rounded-2xl p-6 border border-purple-300 h-full">
                <div className="flex items-center mb-6 gap-2">
                  <div className="p-1 rounded-xl flex items-center justify-center">
                    <img src={iconImg} alt="Monitoring" className="w-8 h-8" />
                  </div>
                  <div className="whitespace-nowrap">
                    <h3 className="text-2xl font-bold">Netraa AIOps</h3>
                    <p className="text-sm uppercase text-purple-500">
                      Intelligent Automation
                    </p>
                  </div>
                </div>

                <div className="h-16 flex items-end gap-2 mb-6">
                  <div className="w-2 h-[40%] bg-purple-300"></div>
                  <div className="w-2 h-[70%] bg-purple-400"></div>
                  <div className="w-2 h-[50%] bg-purple-500"></div>
                  <div className="w-2 h-[90%] bg-purple-600"></div>
                </div>

                <div className="space-y-3 mb-6">
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-purple-500">
                      warning
                    </span>
                    Gen-AI Driven Dashboard Summarization
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-purple-500">
                      refresh
                    </span>
                    RAG Documentation Intelligence
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-purple-500">
                      refresh
                    </span>
                    Predictive Modeling with Seasonality
                  </div>
                  <div className="flex gap-2 text-sm">
                    <span className="material-symbols-outlined text-purple-500">
                      refresh
                    </span>
                    Causal AI for true root cause identification
                  </div>
                </div>

                <span className="text-purple-600 font-bold">
                  & Many more ...
                </span>
              </div>
            </Link>
          </div>
        </section>

        {/* ================= METRICS ================= */}
        <section
          className="grid grid-cols-1 md:grid-cols-3 mt-12 gap-8 text-center"
          id="metrics"
        >
          <div>
            <div className="text-5xl font-bold text-orange-500">50%</div>
            <div className="font-bold">Reduction in MTTR</div>
            <p className="text-sm text-text-muted">
              Resolve incidents faster with automation.
            </p>
          </div>
          <div>
            <div className="text-5xl font-bold text-orange-500">30%</div>
            <div className="font-bold">Cost Savings</div>
            <p className="text-sm text-text-muted">
              Optimize infrastructure spend.
            </p>
          </div>
          <div>
            <div className="text-5xl font-bold text-orange-500">99.9%</div>
            <div className="font-bold">SLA Compliance</div>
            <p className="text-sm text-text-muted">
              Consistently meet SLAs.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}